import {
  Application,
  ProfileType
} from "@platformsh/observability-graph/ContinuousProfiling";

import {
  ObservabilityPipelineContinuousProfilingFlamebearerData,
  ObservabilityPipelineContinuousProfilingTimelineData
} from "Api/observability/pipeline/types";
import useMetricsContext, {
  MetricsContextType
} from "src/organization/pages/project/environment/metrics/hooks/useMetricsContext";

export type ConprofDataContext = {
  application?: Application | null;
  profileType?: ProfileType;
  timelineData?: ObservabilityPipelineContinuousProfilingTimelineData;
  flamebearerData?: ObservabilityPipelineContinuousProfilingFlamebearerData;
  flamebearerSideAData?: ObservabilityPipelineContinuousProfilingFlamebearerData;
  flamebearerSideBData?: ObservabilityPipelineContinuousProfilingFlamebearerData;
};

const useConprofContext = (): MetricsContextType<ConprofDataContext> => {
  const context = useMetricsContext<ConprofDataContext>();
  if (!context) {
    throw new Error(
      "useConprofContext must be used within a MetricsContext.Provider"
    );
  }

  return context;
};

export default useConprofContext;
